import { ITableData } from '../types/generic-table.model';

export const formatTopLineInput = (tableData: ITableData) => {
  const toplineData = JSON.parse(JSON.stringify(tableData));

  // replacing 0 to "-" in header
  for (let i = 0; i < toplineData.header.length; i++) {
    // eslint-disable-next-line prefer-const
    let currElement = toplineData.header[i];
    if(currElement.parent.field_format !="SINGLESELECT_DROPDOWN"){
    currElement.parent.default_value = '-';
  }
}

  const numericColumns = [
    'avg_unit_price_cal_change_ip_perc',
    'avg_unit_price_cal_change_ip_perc_1',
    'avg_unit_price_cal_change_ip_perc_2',
    'avg_unit_price_cal_change_ip_perc_ui_1',
    'avg_unit_price_cal_change_ip_perc_ui_2',
    'mraup_per_unit_cal_change_ip_perc_1',
    'max_scan_cal_change_ip_perc_1',
    'mraup_per_unit_cal_change_ip_perc_2',
    'max_scan_cal_change_ip_perc_2',
    'list_price_per_unit_cal_change_ip_perc',
    'list_price_per_unit_cal_change_ip_perc_1',
    'list_price_per_unit_cal_change_ip_perc_2',
    'list_price_per_unit_cal_change_ip_perc_ui_1',
    'list_price_per_unit_cal_change_ip_perc_ui_2',
    'cogs_per_unit_cal_change_ip_perc',
    'cogs_per_unit_cal_change_ip_perc_1',
    'cogs_per_unit_cal_change_ip_perc_2',
    'cogs_per_unit_cal_change_ip_perc_ui_1',
    'cogs_per_unit_cal_change_ip_perc_ui_2',
    'distribution_cal_change_ip_perc',
    'distribution_cal_change_ip_perc_1',
    'distribution_cal_change_ip_perc_2',
    'trade_rate_perc_cal_additional_ip_perc',
    'trade_rate_perc_cal_additional_ip_perc_1',
    'trade_rate_perc_cal_additional_ip_perc_2'
  ];

  // const formatRows = (rowData) => {
  //   const a = JSON.parse(JSON.stringify(rowData));
  //   a.forEach((ele, index) => {
  //     for (let c = 0; c < numericColumns.length; c++) {
  //       // eslint-disable-next-line no-param-reassign
  //       ele.parent.data[numericColumns[index]] = '-';
  //     }

  //     if (ele.children.length) {
  //       return formatRows(ele.children);
  //     }

  //     return a;
  //   });
  // };

  const formatRows = (rowData) => {
    const formattedData = JSON.parse(JSON.stringify(rowData));

    const updateNumericColumns = (data) => {
      data.forEach((row) => {
        for (let c = 0; c < numericColumns.length; c++) {
          // Update the value of the numeric column to '-'
          // eslint-disable-next-line no-param-reassign
          row.parent.data[numericColumns[c]] = '-';
        }
        if (row.children.length) {
          // Recursively update numeric columns in child rows
          updateNumericColumns(row.children);
        }
      });
    };

    updateNumericColumns(formattedData);

    return formattedData;
  };

  toplineData.row = formatRows(toplineData.row);
  console.log('formated topline: ', toplineData);
  return toplineData;
};

export const a = 1;
